import {
	GET_ENTITY,
} from '@/api/api.commons.js'
import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		datasource: undefined,
		resources: {},
		relations: {},
		timelyEvents: {},
		persistentEvents: {},
		conditionOptions: [{
				value: 'equal',
				label: '等于'
			},
			{
				value: 'equalIgnoreCase',
				label: '等于（忽略大小写）'
			},
			{
				value: 'startsWith',
				label: '以此开头'
			},
			{
				value: 'endsWith',
				label: '以此结尾'
			},
			{
				value: 'startsWithIgnoreCase',
				label: '以此开头（忽略大小写）'
			},
			{
				value: 'endsWithIgnoreCase',
				label: '以此结尾（忽略大小写）'
			},
			{
				value: 'contains',
				label: '包含'
			},
			{
				value: 'containsIgnoreCase',
				label: '包含（忽略大小写）'
			},
			{
				value: 'le',
				label: '不大于'
			},
			{
				value: 'ge',
				label: '不小于'
			},
			{
				value: 'lt',
				label: '小于'
			},
			{
				value: 'gt',
				label: '大于'
			},
			{
				value: 'isNull',
				label: '为空'
			},
			{
				value: 'isNotNull',
				label: '不为空'
			}
		],
		field: function(arr) {
			const field = []
			let keyAt, keyJt
			for (const i in arr) {
				const key = arr[i]
				if (key.startsWith('#')) {
					keyJt = key
					continue
				}
				if (key.endsWith('@')) {
					keyAt = key
					continue
				}
				field.push(key)
			}
			if (keyJt) {
				field[field.length - 1] = field[field.length - 1] + keyJt
			}
			if (keyAt) {
				field[0] = keyAt + field[0]
			}
			return field.join('.')
		},
		to_field: function(str) {
			let [paths, ath] = str.split('#')
			let path = paths.includes('@') ? undefined : paths
			let der
			if (path === undefined) {
				paths = paths.split('@').filter(t => t !== undefined)
				path = paths[1]
				der = paths[0]
			}
			let field = path.split('.').filter(t => t !== undefined)
			if (der) {
				field = [...field, `${der}@`]
			}
			if (ath) {
				field.push(`#${ath}`)
			}
			return field
		},
	},
	getters: {
		rootDatasource(state) {
			return (key) => state.datasource && state.datasource.content[key]
		},
		field(state) {
			return state.field
		},
		to_field(state) {
			return state.to_field
		},
		conditionOptions(state) {
			return state.conditionOptions
		},
		value_label(state) {
			return (type, value, keys) => {
				let resource = state[`${type}s`][value]
				if (resource === undefined) {
					return ''
				}
				const result = []
				let fieldNameMapper = resource.fieldNameMapper
				let algorithms = resource.algorithms
				let derivedMetrics = resource.derivedMetrics
				let derivedMetric
				let algorithm
				let joinFieldMapper = resource.joinFieldMapper
				for(let i in keys) {
					if (fieldNameMapper && fieldNameMapper[keys[i]]) {
						result.push(fieldNameMapper[keys[i]])
						derivedMetric = derivedMetrics[keys[i]]
						algorithm = algorithms[keys[i]]
					}
					if (i < keys.length - 1) {
						let join = joinFieldMapper[keys[i]]
						if (!join) {
							continue
						}
						switch (join.type) {
							case 'com.learnyeaiframework.analysis.common.v1.beans.PersistentEvent':
								resource = state['persistentEvents'][join.resourceId]
								break
							case 'com.learnyeaiframework.analysis.common.v1.beans.TimelyEvent':
								resource = state['timelyEvents'][join.resourceId]
								break
							case 'com.learnyeaiframework.analysis.common.v1.beans.Relation':
								resource = state['relations'][join.resourceId]
								break
							default:
								resource = state['resources'][join.resourceId]
								break
						}
						fieldNameMapper = resource.fieldNameMapper 
						joinFieldMapper = resource.joinFieldMapper
						algorithms = resource.algorithms
						derivedMetrics = resource.derivedMetrics
					}
				}
				for (let key of keys) {
					if (derivedMetric) {
						for (let value of derivedMetric) {
							if (key === `${value.type}@`) {
								result.push(value.name)
								continue
							}
						}
					}
					if (algorithm) {
						for (let value of algorithm) {
							if (key === `#${value.type}`) {
								result.push(value.name)
								continue
							}
						}
					}
				}
				return result.join(" / ")
			}
		},
		value_type(state) {
			return (type, value, keys) => {
				let resource = state[`${type}s`][value]
				if (resource === undefined) {
					return ''
				}
				const joinFieldMapper = resource.joinFieldMapper
				for(let i in keys) {
					if (i < keys.length - 1) {
						let join = joinFieldMapper[keys[i]]
						if (!join) {
							continue
						}
						switch (join.type) {
							case 'com.learnyeaiframework.analysis.common.v1.beans.PersistentEvent':
								resource = state['persistentEvents'][join.resourceId]
								break
							case 'com.learnyeaiframework.analysis.common.v1.beans.TimelyEvent':
								resource = state['timelyEvents'][join.resourceId]
								break
							case 'com.learnyeaiframework.analysis.common.v1.beans.Relation':
								resource = state['relations'][join.resourceId]
								break
							default:
								resource = state['resources'][join.resourceId]
								break
						}
					}
				}
				const fieldTypeMapper = resource.fieldTypeMapper
				return fieldTypeMapper[keys[keys.length - 1]]
			}
		},
		resources_labels(state, data, rootState) {
			const hasAuthoritiy = (type, table, field) => {
				if (!rootState.system.account.userinfo) {
					return true
				}
				if (rootState.system.account.userinfo.id === 'root') {
					return true
				}
				const authorities = rootState.system.account.userinfo.authorities
				if (!authorities) {
					return true
				}
				if (authorities.filter(t => t.authority === 'ROLE_ADMIN').length > 0) {
					return true
				}
				const search = [type, table, field].filter(t => t !== undefined).join("::")
				return authorities.filter(t => t.authority === search).length > 0
			}
			return (type) => {
				return Object.keys(state[`${type}s`]).map(value => {
					const disabled = !hasAuthoritiy(type, value)
					return {
						value,
						label: `${state[`${type}s`][value]['name'] || state[`${type}s`][value]['id']}${disabled?`(没有访问权限)`:''}`,
						disabled
					}
				})
			}
		},
		resources_x_props(state, data, rootState) {
			const hasAuthoritiy = (type, table, field) => {
				if (!rootState.system.account.userinfo) {
					return true
				}
				if (rootState.system.account.userinfo.id === 'root') {
					return true
				}
				const authorities = rootState.system.account.userinfo.authorities
				if (!authorities) {
					return true
				}
				if (authorities.filter(t => t.authority === 'ROLE_ADMIN').length > 0) {
					return true
				}
				const search = [type, table, field].filter(t => t !== undefined).join("::")
				return authorities.filter(t => search.startsWith(t.authority)).length > 0
			}
			return (type, value) => {
				return {
					expandTrigger: 'hover',
					checkStrictly: true,
					lazy: true,
					lazyLoad: (node, resolve) => {
						const {
							level
						} = node
						if (level === 0) {
							const resource = state[`${type}s`][value]
							if (resource === undefined) {
								return resolve()
							}
							const result = []
							const fieldNameMapper = resource.fieldNameMapper
							for (const field in fieldNameMapper) {
								const fieldName = fieldNameMapper[field]
								const disabled = !hasAuthoritiy(type, resource.id, field)
								const tmp = {
									value: field,
									label: `${fieldName}${disabled?`(没有访问权限)`:''}`,
									resource,
									field,
									leaf: (resource === undefined || (resource.joinFieldMapper && resource
										.joinFieldMapper[field] ===
										undefined)) && resource.derivedMetrics[field] === undefined,
									disabled
								}
								result.push(tmp)
							}
							return resolve(result)
						} else {
							const {
								resource,
								field,
								children = []
							} = node.data
							if (children.length > 0) {
								return resolve()
							}
							const result = []
							if (resource === undefined) {
								return resolve([])
							}
							const joinFieldMapper = resource.joinFieldMapper
							const derivedMetrics = resource.derivedMetrics
							const derivedMetric = derivedMetrics[field]
							if (derivedMetric !== undefined) {
								for (const value of derivedMetric) {
									const disabled = !hasAuthoritiy(type, resource.id, field)
									const derivedMetricTmp = {
										value: `${value.type}@`,
										label: `${value.name}${disabled?`(没有访问权限)`:''}`,
										leaf: true
									}
									result.push(derivedMetricTmp)
								}
							}
							const join = joinFieldMapper && joinFieldMapper[field]
							if (join !== undefined) {
								let resource
								switch (join.type) {
									case 'com.learnyeaiframework.analysis.common.v1.beans.PersistentEvent':
										resource = state['persistentEvents'][join.resourceId]
										break
									case 'com.learnyeaiframework.analysis.common.v1.beans.TimelyEvent':
										resource = state['timelyEvents'][join.resourceId]
										break
									case 'com.learnyeaiframework.analysis.common.v1.beans.Relation':
										resource = state['relations'][join.resourceId]
										break
									default:
										resource = state['resources'][join.resourceId]
										break
								}
								if (resource) {
									const fieldNameMapper = resource.fieldNameMapper
									for (const field in fieldNameMapper) {
										const fieldName = fieldNameMapper[field]
										const disabled = !hasAuthoritiy(type, resource.id, field)
										const tmp = {
											value: field,
											label: `${fieldName}${disabled?`(没有访问权限)`:''}`,
											resource,
											field,
											leaf: (resource === undefined || resource.joinFieldMapper[
												field] === undefined) && resource.derivedMetrics[
												field] === undefined,
											disabled
										}
										result.push(tmp)
									}
								}
							}
							return resolve(result)
						}
					}
				}
			}
		},
		resources_y_props(state, data, rootState) {
			const hasAuthoritiy = (type, table, field) => {
				if (!rootState.system.account.userinfo) {
					return true
				}
				if (rootState.system.account.userinfo.id === 'root') {
					return true
				}
				const authorities = rootState.system.account.userinfo.authorities
				if (!authorities) {
					return true
				}
				if (authorities.filter(t => t.authority === 'ROLE_ADMIN').length > 0) {
					return true
				}
				const search = [type, table, field].filter(t => t !== undefined).join("::")
				return authorities.filter(t => search.startsWith(t.authority)).length > 0
			}
			return (type, value) => {
				return {
					expandTrigger: 'hover',
					lazy: true,
					lazyLoad: (node, resolve) => {
						const {
							level
						} = node
						if (level === 0) {
							const resource = state[`${type}s`][value]
							if (resource === undefined) {
								return resolve([])
							}
							const result = []
							const fieldNameMapper = resource.fieldNameMapper
							for (const field in fieldNameMapper) {
								const fieldName = fieldNameMapper[field]
								const tmp = {
									value: field,
									label: fieldName,
									resource,
									field,
									leaf: false
								}
								result.push(tmp)
							}
							return resolve(result)
						} else {
							const {
								resource,
								field,
								children = []
							} = node.data
							if (children.length > 0) {
								return resolve()
							}
							if (resource === undefined) {
								return resolve([])
							}
							const result = []
							const algorithms = resource.algorithms
							const joinFieldMapper = resource.joinFieldMapper
							const derivedMetrics = resource.derivedMetrics
							const derivedMetric = derivedMetrics[field]
							const fieldAlgorithm = algorithms[field]
							const metrics = [{
									type: 'countDistinct',
									name: '去重数'
								},
								{
									type: 'sum',
									name: '求和'
								},
								{
									type: 'max',
									name: '最大值'
								},
								{
									type: 'min',
									name: '最小值'
								},
								{
									type: 'avg',
									name: '平均值'
								}
							]
							for (const algorithm of fieldAlgorithm) {
								const disabled = !hasAuthoritiy(type, resource.id, field)
								result.push({
									value: `#${algorithm.type}`,
									label: `${algorithm.name}${disabled?`(没有访问权限)`:''}`,
									leaf: true,
									disabled: !hasAuthoritiy(type, resource.id, field)
								})
							}
							if (derivedMetric !== undefined) {
								for (const value of derivedMetric) {
									const derivedMetricTmp = {
										value: `${value.type}@`,
										label: value.name,
										children: [],
										leaf: false
									}
									for (const algorithm of metrics) {
										const disabled = !hasAuthoritiy(type, resource.id, field)
										derivedMetricTmp.children.push({
											value: `#${algorithm.type}`,
											label: `${algorithm.name}${disabled?`(没有访问权限)`:''}`,
											leaf: true,
											disabled
										})
									}
									result.push(derivedMetricTmp)
								}
							}
							const join = joinFieldMapper && joinFieldMapper[field]
							if (join !== undefined) {
								let resource
								switch (join.type) {
									case 'com.learnyeaiframework.analysis.common.v1.beans.PersistentEvent':
										resource = state['persistentEvents'][join.resourceId]
										break
									case 'com.learnyeaiframework.analysis.common.v1.beans.TimelyEvent':
										resource = state['timelyEvents'][join.resourceId]
										break
									case 'com.learnyeaiframework.analysis.common.v1.beans.Relation':
										resource = state['relations'][join.resourceId]
										break
									default:
										resource = state['resources'][join.resourceId]
										break
								}
								const fieldNameMapper = resource.fieldNameMapper
								for (const field in fieldNameMapper) {
									const fieldName = fieldNameMapper[field]
									const tmp = {
										value: field,
										label: fieldName,
										resource,
										field,
										leaf: false
									}
									result.push(tmp)
								}
							}
							return resolve(result)
						}
					}
				}
			}
		}
	},
	mutations: {
		put_datasource(state, data) {
			state.datasource = data
		},

		clear_resources(state) {
			state.resources = {}
			state.relations = {}
			state.timelyEvents = {}
			state.persistentEvents = {}
		},

		put_resources(state, {
			id,
			record
		}) {
			Vue.set(state.resources, id, record)
		},
		put_relations(state, {
			id,
			record
		}) {
			Vue.set(state.relations, id, record)
		},
		put_timelyEvents(state, {
			id,
			record
		}) {
			Vue.set(state.timelyEvents, id, record)
		},
		put_persistentEvents(state, {
			id,
			record
		}) {
			Vue.set(state.persistentEvents, id, record)
		},

	},
	actions: {
		async fetch_resources({
			commit
		}) {
			const datasource = await GET_ENTITY({
				uri: `/systemClients/root/dataSource`
			})
			commit('put_datasource', datasource)
			commit('clear_resources')
			const {
				_embedded: {
					resourceEntities: resources
				}
			} = await GET_ENTITY({
				uri: datasource._links.resources.href.substring(0, datasource._links.resources.href.indexOf(
					'{?'))
			})
			for (let {
					id,
					name,
					schemaName,
					resourceType
				} of resources) {
				GET_ENTITY({
					uri: `${datasource._links.self.href}/profile/${resourceType}/${schemaName}/${name}`
				}).then((resource) => {
					commit(`put_${resourceType}s`, {
						id,
						record: {
							...resource,
							uuid: id
						}
					})
				})
			}
		},

		async fetch_resource({
			commit
		}, {
			id,
			params = {}
		}) {
			const entity = await GET_ENTITY({
				uri: `/resourceEntities/${id}`,
				params
			})
			let {
				resourceType
			} = entity
			const resource = await GET_ENTITY({
				uri: `${entity._links.self.href}/profile`,
				params
			})
			commit(`put_${resourceType}s`, {
				id: entity.id,
				record: {
					...resource,
					uuid: entity.id
				}
			})
		},

		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		async load({
			dispatch,
		}, auth = true) {
			auth && dispatch('fetch_resources')
		}
	}
}
